export enum OnboardingStep {
  SECURITY_REVIEW = 'securityReview',
  SECURITY_REVIEW_MANUAL = 'securityReviewManual',
  VERIFICATION_IN_PROGRESS = 'verificationInProgress',
  PENDING_VERIFICATION = 'pendingVerification',
  MANUAL_VERIFICATION = 'manualVerification',
  RETRY_VERIFICATION = 'retryVerification',
  REASSESSMENT = 'reassessment',
  DEPOSIT = 'deposit',
}
